<template>
  <div v-if="morphedImage" class="cropped">
    <RawImage
      :scale="0.9"
      :imageData="morphedImage"
      @click="$emit('click', $event)"
    />
  </div>
  <div v-else>Loading...</div>
</template>

<script>
import { morphFaces } from "@/facemorpher/facemorph";
// import { detectFaceLandmarks } from "@/facemorpher/facelandmarks";
import RawImage from "@/components/RawImage.vue";

export default {
  components: {
    RawImage,
  },
  props: {
    img1: {
      type: String,
      required: true,
    },
    img2: {
      type: String,
      required: true,
    },
    landmarks1: {
      type: Object,
      required: true,
    },
    landmarks2: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      morphedImage: null,
      image1: null,
      image2: null,
    };
  },
  methods: {
    async reload() {
      if (!this.img1 || !this.img2) return;

      this.image1 = await this.loadImage(this.img1);
      this.image2 = await this.loadImage(this.img2);

      const landmarks1 = this.landmarks1;
      const landmarks2 = this.landmarks2;
      console.log(landmarks1, landmarks2);
      this.morphedImage = await morphFaces(
        this.image1,
        this.image2,
        landmarks1,
        landmarks2
      );
    },
    loadImage(dataUrl) {
      return new Promise((resolve) => {
        const image = new Image();
        image.src = dataUrl;
        image.onload = () => {
          resolve(image);
        };
      });
    },
  },
  mounted() {
    this.reload();
  },
  watch: {
    img1() {
      this.reload();
    },
    img2() {
      this.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.cropped {
  border-radius: 100%;
  overflow: hidden;
  width: 220px;
  height: 293.3px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: 1rem solid transparent;
}

.active {
  border: 1rem solid green;
}
.selected {
  border: 1rem solid blue;
}
</style>
